import React, { createContext, useEffect, useState } from 'react'
import { getAllProducts, getCart } from '../apis'
import { useDispatch } from 'react-redux'
import { setCartItems } from '../redux/cartSlice'
import { useRealtimeEvent } from '../hooks/useRealtimeEvent'


const MainContext = createContext()

const MainContextProvider = ({children}) => {
    const dispatch = useDispatch()
    const [token, setToken] = useState("")
    const [products, setProducts] = useState([])
    const [orderPlaced, setOrderPlaced] = useState(false)

    const fetchProductList = async () => {
        const products = await getAllProducts()
        setProducts(products)
    }

    useEffect(() => {
        const fetchCartItems = async (token) => {
            try {
                const response = await getCart({headers:{token}});
                if (response.data.success) {
                    dispatch(setCartItems(response.data.cartData));
                    setOrderPlaced(false)
                } else {
                    // Token is invalid/expired — clear the stale session so the
                    // rest of the app (e.g. the header) stops treating the user
                    // as logged in, without throwing or breaking other calls.
                    localStorage.removeItem("token");
                    setToken("");
                }
            } catch (error) {
                // Log only the message — the full axios error object includes
                // the request config, which carries the JWT itself.
                console.error("Error fetching cart items:", error.message);
            }
        };

        if (token) {
            fetchCartItems(token);
        }
    }, [dispatch, token, orderPlaced]);

    useEffect(() => {
        async function loadData () {
            await fetchProductList()
        }
        loadData()
        
        // when we reload the webpage, the token should set again, otherwise the user will get logged-out
        if (localStorage.getItem("token")) {
            setToken(localStorage.getItem("token"))
        }
    }, [])

    // Live sync with the admin panel: when a product/category is added,
    // edited, or removed, refetch the catalog instead of waiting for a
    // manual page reload. The event only ever carries a change hint (see
    // backend/utils/realtime.js) — the refetch is what's actually trusted.
    useRealtimeEvent("catalog:changed", (data) => {
        if (!data.resource || data.resource === "product" || data.resource === "category") {
            fetchProductList()
        }
    })

  return (
    <MainContext.Provider
    value={{
        token,
        setToken,
        products,
        setProducts,
        orderPlaced,
        setOrderPlaced
    }}>
        {children}
    </MainContext.Provider>
  )
}

export { MainContextProvider, MainContext }